import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { EntraAuthService } from './core/auth/entra-auth.service';
import { CookieBannerComponent } from './shared/cookies/cookie-banner/cookie-banner.component';
import { FooterComponent, HeaderComponent } from './shared/layout';

@Component({
  selector: 'mkzs-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CookieBannerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  protected readonly authService = inject(EntraAuthService);

  protected async signIn(): Promise<void> {
    await this.authService.signIn();
  }

  protected async signOut(): Promise<void> {
    await this.authService.signOut();
  }
}
